module.exports = __webpack_public_path__ + "img/天山雪莲.bc0e31f7.jpg";